import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {CarePlanServiceGroupTypeDgSearchResults} from "../models/datagrid-search-results/care-plan-service-group-type.dg-search-results.model";
import {CarePlanServiceGroupTypeService} from "../providers/care-plan-service-group-type.service";

@Injectable()
export class CarePlanServiceGroupTypesResolve implements Resolve<CarePlanServiceGroupTypeDgSearchResults> {
  constructor(private carePlanServiceGroupTypeService: CarePlanServiceGroupTypeService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<CarePlanServiceGroupTypeDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.carePlanServiceGroupTypeService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'name').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
